import { useQuery } from "@tanstack/react-query";

import { wishlistApi } from "@/features/engagement/services/wishlist.api";
import { useAppSelector } from "@/store/hooks";

/**
 * One shared query (`["wishlist"]`), used two ways: the Wishlist page reads
 * `.data` directly for the full grid; Home/Search/Product Details only need
 * `.data` to derive a `Set` of favorited ids for `ProductCard`'s
 * `isFavorite` prop. Same query key everywhere means one network request
 * serves both, not a per-page favorite-status endpoint.
 */
export function useWishlist() {
  const isAuthenticated = useAppSelector((state) => state.auth.status === "authenticated");
  return useQuery({
    queryKey: ["wishlist"],
    queryFn: wishlistApi.getWishlist,
    enabled: isAuthenticated,
  });
}
